var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModisehBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.414,
    height: 21.721,
    viewBox: "0 0 108.414 21.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.668,0a9.57,9.57,0,1,0,9.458,9.57A9.525,9.525,0,0,0,133.668,0Zm0,17.373c-3.343,0-6.064-3.492-6.064-7.785S130.325,1.8,133.668,1.8,139.73,5.3,139.73,9.588,137.009,17.373,133.668,17.373Z",
    transform: "translate(-103.153 0)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.385,
    height: 19.141,
    transform: "translate(60.988 0.004)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.739.185,251.75.17h-3.39v19.1h7.29a9.545,9.545,0,0,0,.09-19.088Zm-.09,17.33h-3.9V1.979h3.9c3.34,0,6.055,3.484,6.055,7.769s-2.716,7.768-6.055,7.768Z",
    transform: "translate(-206.257 -0.141)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.581.023V19.158h-3.39V10.493h-7.7v8.658H554.1V.02h3.391V8.735h7.7V.023Z",
    transform: "translate(-460.167 -0.016)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.463,9.663,0,0V19.143H1.775V6.747l4.6,4.689h0l2.273,2.309h0l1.794,1.841.017.019a2.121,2.121,0,0,1,.531,1.409,2.078,2.078,0,0,1-2.053,2.1,2.019,2.019,0,0,1-.707-.127,2.734,2.734,0,0,1-1-4.511l.125-.125h0l.492-.5L6.611,12.577,6,13.2l-.044.046a5.069,5.069,0,0,0-.5,6.345,4.867,4.867,0,0,0,3.972,2.133H9.47a4.8,4.8,0,0,0,2.923-.98A4.976,4.976,0,0,0,14.4,16.952v-.224A5.108,5.108,0,0,0,12.923,13.2l-2.217-2.273L15.5,6.035V19.143h3.426V0Z",
    transform: "translate(0 0)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.219,12.234a4.867,4.867,0,0,0-.909-1.449,7.885,7.885,0,0,0-1.446-1.243,21.625,21.625,0,0,0-1.933-1.166c-.37-.2-.722-.393-1.061-.585l-.712-.393-.039-.022c-.12-.066-.237-.136-.351-.21l-.054-.032h0a3.955,3.955,0,0,1-1.473-1.724,2.3,2.3,0,0,1-.2-1.187.206.206,0,0,0,0-.029V4.144a2.137,2.137,0,0,1,.046-.27,2.509,2.509,0,0,1,.722-1.258,3.113,3.113,0,0,1,1.238-.759h.008c.078-.027.159-.054.242-.078l.117-.034c.083-.022.17-.042.253-.061h.031a7.217,7.217,0,0,1,2.712-.014,7.383,7.383,0,0,1,2.4.848V.764l-.363-.151A9.47,9.47,0,0,0,398.827,0a7.866,7.866,0,0,0-2.341.339,6.093,6.093,0,0,0-1.961,1,5.033,5.033,0,0,0-1.356,1.61,4.577,4.577,0,0,0-.509,2.17,4.979,4.979,0,0,0,.27,1.7,4.374,4.374,0,0,0,.848,1.41,7.751,7.751,0,0,0,1.4,1.2c.532.363,1.187.758,1.938,1.17.649.363,1.226.7,1.722,1a4.206,4.206,0,0,1,2.022,2.034,2.328,2.328,0,0,1,.2,1.2.067.067,0,0,0,0,.017v.042a2.111,2.111,0,0,1-.046.275,2.519,2.519,0,0,1-.624,1.16,2.582,2.582,0,0,1-.642.522,4.44,4.44,0,0,1-2.448.619,7.837,7.837,0,0,1-1.59-.117,6.794,6.794,0,0,1-3.111-1.338v1.916l.275.17a4.436,4.436,0,0,0,.975.444,11.484,11.484,0,0,0,1.161.319,11.923,11.923,0,0,0,1.2.2,9.056,9.056,0,0,0,3.5-.239,5.957,5.957,0,0,0,2-.954,4.5,4.5,0,0,0,1.356-1.649,5.137,5.137,0,0,0,.481-2.265A4.66,4.66,0,0,0,403.219,12.234Z",
    transform: "translate(-326.037 0.001)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.744,17.388h-8.773V10.471h7.266V8.718h-7.266V1.827h8.769V.024L472.971.012l-3.4,0V19.151h2.984l0,0h9.188Z",
    transform: "translate(-389.967 -0.008)",
    fill: "#d8d8d8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModisehBlack);
export default __webpack_public_path__ + "static/media/modiseh_black.7e486ad1cb73cf39ee6c946767e4e316.svg";
export { ForwardRef as ReactComponent };